
<section class="company-dialog-shell">
  <header class="company-dialog-header">
    <h2 *ngIf="isNewCustomer">Nytt företag</h2>
    <h2 *ngIf="!isNewCustomer" matTooltip="{{customer?.Id}}">{{customer.Name}}</h2>
    <button mat-icon-button type="button" (click)="onClose()" aria-label="Stäng dialogen" matTooltip="Stäng">
      <mat-icon>close</mat-icon>
    </button>
  </header>

<mat-dialog-content class="modal-content">
  <form #personForm="ngForm" novalidate class="company-form">

    <!-- Searchbox only shown to users adding a new business customer -->
    <div *ngIf="isNewCustomer" class="form-wide">
      <div style="margin: 20px 0 0 0;">
        <mat-form-field appearance="fill" floatLabel="always">
          <mat-label>Organisationsnummer / VAT</mat-label>
          <input matInput [(ngModel)]="searchAccountValue" (ngModelChange)="orgNumberValidCheck($event)" name="searchCompany" id="searchCompany" type="text" placeholder="NNNNNN-NNNN">
          <mat-icon *ngIf="orgNumberValid" color="accent" matSuffix matTooltipPosition="before" matTooltip="Företaget kontrollerat hos Hitta.se" style="color: green;">check</mat-icon>
          <mat-icon *ngIf="!orgNumberValid" color="accent" matSuffix matTooltipPosition="before" matTooltip="Företaget kan ej verifieras" style="color: red;">close</mat-icon>
        </mat-form-field>
        <span class="errormessage">{{errorMessageOrgnr}}</span>
      </div>
    </div>

    <!-- Regular text field shown to admin, and disabled for users when a customer is once saved -->
    <div *ngIf="!isNewCustomer" class="org-number-field">
      <mat-form-field appearance="fill" floatLabel="always">
        <mat-label>Organisationsnummer / VAT</mat-label>
        <input matInput [disabled]="true" type="text" [(ngModel)]='customer.OrgNumber' placeholder="NNNNNN-NNNN (10 siffror och bindestreck)" required name="OrgNumber">
      </mat-form-field>
    </div>

    <mat-form-field appearance="fill" floatLabel="always" *ngIf="!isNewCustomer" class="country-field">
      <mat-label>Land</mat-label>
      <mat-select [disabled]="true" name="country" [ngModel]="customer?.Country?.Id" (ngModelChange)="customer && customer.Country ? (customer.Country.Id = $event) : null; getCountryName($event); orgNumberValidCheck(searchAccountValue)" [ngModelOptions]="{ standalone: true }" required>
        <mat-option *ngFor="let c of countries" [value]="c.Id">
          {{ c.Name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Other form fields are shown when orgnr is added, or if private person customer. Always shown to admin -->
    <mat-form-field appearance="fill" floatLabel="always" *ngIf="orgNumberValid || !isNewCustomer" class="company-name-field">
      <mat-label>Namn</mat-label>
      <input matInput type="text" [(ngModel)]='customer.Name' required name="name">
    </mat-form-field>

    <mat-form-field appearance="fill" floatLabel="always" *ngIf="pNrValid || orgNumberValid || !isNewCustomer">
      <mat-label>Adress</mat-label>
      <input matInput type="text" [(ngModel)]='customer.Address' required name="Address">
    </mat-form-field>

    <mat-form-field appearance="fill" floatLabel="always" *ngIf="pNrValid || orgNumberValid || !isNewCustomer">
      <mat-label>C/o</mat-label>
      <input matInput type="text" [disabled]="customer.CoLocked && !isAdmin" [(ngModel)]='customer.Co' name="Co">
    </mat-form-field>

    <mat-form-field appearance="fill" floatLabel="always" *ngIf="pNrValid || orgNumberValid || !isNewCustomer">
      <mat-label>Postnummer</mat-label>
      <input matInput type="text" [(ngModel)]='customer.Zip' required name="Zip">
    </mat-form-field>

    <mat-form-field appearance="fill" floatLabel="always" *ngIf="pNrValid || orgNumberValid || !isNewCustomer">
      <mat-label>Ort</mat-label>
      <input matInput type="text" [(ngModel)]='customer.City' required name="City">
    </mat-form-field>

    <mat-form-field appearance="fill" floatLabel="always" *ngIf="pNrValid || orgNumberValid || !isNewCustomer">
      <mat-label>Telefon</mat-label>
      <input matInput type="text" [disabled]="customer.PhoneLocked && !isAdmin" (ngModelChange)="phoneNumberValidCheck($event)" [(ngModel)]='customer.Phone' name="Phone">
    </mat-form-field>
    <span class="errormessage">{{errorMessagePhoneNr}}</span>

    <mat-form-field appearance="fill" floatLabel="always" *ngIf="appId == 1 && (pNrValid || orgNumberValid || !isNewCustomer) || isAdmin">
      <mat-label>E-post för att motta faktura</mat-label>
      <input matInput type="email" [disabled]="customer.InvoiceEmailLocked && !isAdmin" [(ngModel)]='customer.InvoiceEmail' name="InvoiceEmail">
      <!--<mat-icon *ngIf="!correctEmail.valid && !customer.InvoiceEmailLocked" matSuffix color="accent">warning</mat-icon>-->
    </mat-form-field>

    <mat-form-field appearance="fill" floatLabel="always" *ngIf="appId == 2 && (pNrValid || orgNumberValid || !isNewCustomer)">
      <mat-label>E-post för kontakt</mat-label>
      <input matInput type="email" [(ngModel)]='customer.Email' name="Email">
    </mat-form-field>

    <mat-form-field appearance="fill" floatLabel="always" *ngIf="appId == 2 || isAdmin">
      <mat-label>E-post för fakturakopia</mat-label>
      <input matInput type="email" [(ngModel)]='customer.InvoiceEmailCopy' name="Epost för fakturakopia">
    </mat-form-field>

    <mat-form-field appearance="fill" floatLabel="always" *ngIf="(appId == 2 && customer.MailinInboxEmail != null) || isAdmin">
      <mat-label>E-post för mailin</mat-label>
      <input matInput [disabled]="!isAdmin" type="email" [(ngModel)]='customer.MailinInboxEmail' name="Epost för mailin">
    </mat-form-field>

    <!--<mat-form-field floatLabel="always" *ngIf="appId == 2 || isAdmin" style="width: 100%; margin-bottom:30px;">
    <input matInput type="email" [(ngModel)]='customer.InvoiceEmailCopy' placeholder="Epost för fakturakopia" name="Epost för fakturakopia">
  </mat-form-field>-->



  </form>

</mat-dialog-content>

  <footer class="company-dialog-footer">
    <div class="company-dialog-actions">
      <button mat-stroked-button type="button" (click)="onClose()">Avbryt</button>
      <button mat-flat-button color="accent" class="confirm-action" [disabled]="!formValid() || !orgNumberValid" (click)="save(customer)">
        <mat-icon>check</mat-icon>
        Spara
      </button>
    </div>
    <div class="dialog-error" *ngIf="errorMessage">{{errorMessage}}</div>
  </footer>
</section>

<!--<mat-dialog-actions class="modal-footer">
 
</mat-dialog-actions>-->

